import { createFileRoute } from '@tanstack/react-router';
import { InviteEmail } from '@/pages';

/**
 * Email capture step of the creator invite OTP sign-up flow.
 */
export const Route = createFileRoute('/_public/invite/email')({
  component: InviteEmail,
});
